import { render } from "./icon-flag.vue?vue&type=template&id=5fc6baf9"
import script from "./icon-flag.vue?vue&type=script&lang=js"
export * from "./icon-flag.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__